import type { AppRouteProps } from '@/constants/routes'
import { useAuthContext } from '@offer/auth-lib'
import { VpLoader } from '@vtmn-play/react/headless'
import { Outlet, Route, Routes } from 'react-router'
import { AuthenticatedApp } from '@/components/authenticatedApp'
import { NON_SEASON_ROUTES, SEASON_ROUTES } from '@/constants/routes'
import { useAmplitude } from '@/hooks/amplitude/useAmplitude'
import { useBeamer } from '@/hooks/beamer/useBeamer'
import { useMedallia } from '@/hooks/medallia/useMedallia'
import { FavoriteViewsPage } from '@/pages/FavoriteViewsPage/FavoriteViewsPage'
import { Layout } from '@/routing/Layout/Layout'
import { RequireSeasonGuard } from '@/routing/RequireSeasonGuard'

export function App() {
  const { isAuthenticated, user } = useAuthContext()

  useAmplitude(user, isAuthenticated)
  useBeamer(user?.id)
  useMedallia()

  const renderRoute = ({ Component, path }: AppRouteProps) => (
    <Route
      key={path}
      path={path}
      element={<Component />}
    />
  )

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route
          element={isAuthenticated
            ? <AuthenticatedApp Component={Outlet} />
            : (
                <div className="loader-container global">
                  <VpLoader size="large" />
                </div>
              )}
        >
          <Route path="/favorites" element={<FavoriteViewsPage />} />
          <Route path="/favorites/:folderRoute" element={<FavoriteViewsPage />} />
          <Route element={<RequireSeasonGuard />}>
            {NON_SEASON_ROUTES.map(renderRoute)}
            {SEASON_ROUTES.map(renderRoute)}
          </Route>
        </Route>
      </Route>
    </Routes>
  )
}

export default App
